module.exports = __webpack_public_path__ + "static/media/starter-mobile.e2508e11.svg";